import { useRetrieveDepartment } from '../api';

function Dept(props: { deptId: any }) {
    const { data: deptData } = useRetrieveDepartment(props.deptId);

    return <td>{deptData?.data.name}</td>;
}

export default Dept;
